import { type DependencyList, useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';

import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/modules/storage';

export function useShowComponentOnce(
  sessionStorageKey: string,
  sessionStorageDependencyList: DependencyList = []
) {
  const [shouldShow, setShouldShow] = useState(false);
  const [ref, isInView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  useEffect(() => {
    if (isInView) {
      setSessionStorageItem(sessionStorageKey, 'true');
    }
  }, [isInView]);

  useEffect(() => {
    const hasSeen = getSessionStorageItem(sessionStorageKey) === 'true';
    setShouldShow(!hasSeen);
  }, sessionStorageDependencyList);

  return [ref, shouldShow] as const;
}
